export const drawerWidth = 300
export interface Layout {
  isMenuOpen?: boolean,
  isFilterOpen?: boolean
}
